<template>
    <div id="content_page" class="scroll-y">
        <div id="content_page_layout">
            <header v-if="!isMobile" id="augmentations_header">
                <div id="header_content" :class="{'header_content_mobile': isMobile}">
                    <h3 v-if="isPro">
                        {{ experience.name }}
                    </h3>
                    <h3 v-else>
                        Mon Blinkl Stories
                    </h3>
                    <p v-if="isPro">
                        {{ experience.description }}
                    </p>
                </div>
            </header>
            <div id="main_box_augment">
                <augmentations-content />
            </div>
            <transition name="fade">
                <modal-delete-augmentation v-if="mode === 'deleteValidate'" />
                <modal-new-augmentation v-if="mode === 'add'" />
                <modal-frozen-experience v-if="mode === 'frozen'" />
                <modal-test-experience v-if="modeExperience === 'test'" />
            </transition>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'Augmentations',
        components: {
            AugmentationsContent: () => import('../components/augmentations/AugmentationsContent'),
            ModalDeleteAugmentation: () => import('../components/augmentations/modals/ModalDeleteAugmentation'),
            ModalNewAugmentation: () => import('../components/augmentations/modals/ModalNewAugmentation'),
            ModalFrozenExperience: () => import('../components/augmentations/modals/ModalFrozenExperience'),
            ModalTestExperience: () => import('../components/experiences/modals/ModalTestExperience')
        },
        computed: {
            ...mapGetters('augmentations', ['experience', 'mode']),
            modeExperience: function () {
                return this.$store.state.experiences.mode;
            },
            ...mapGetters('app', ['isPro', 'isMobile'])
        },
        watch: {
            'experience.img': function () {
                this.setImageBackground();
            }
        },
        created () {
            this.cleanAugmentations().then(() => {
                return this.loadExperience(this.$route.params.experienceToken);
            }).then(() => {
                return this.loadAugmentations();
            }).catch((err) => {
                this.$toasted.error(err);
            });
        },
        mounted () {
            this.$el.addEventListener('scroll', this.throttle(this.callback, 100));
            this.setImageBackground();
        },
        destroyed () {
            this.removeBackground();
        },
        methods: {
            ...mapActions('augmentations', ['cleanAugmentations', 'loadExperience', 'loadAugmentations']),
            throttle: function (fn, wait) {
                var time = Date.now();
                return function () {
                    if ((time + wait - Date.now()) < 0) {
                        fn();
                        time = Date.now();
                    }
                };
            },
            callback: function () {
                let _this = this;
                if (document.getElementById('button_toggle_menu')) {
                    document.getElementById('button_toggle_menu').style.top = 17 - this.$el.scrollTop + 'px';
                    setTimeout(function () {
                        document.getElementById('button_toggle_menu').style.top = 17 - _this.$el.scrollTop + 'px';
                    }, 100);
                }
            },
            setImageBackground: function () {
                let element = document.getElementById('background_image');
                if (this.experience.img) {
                    element.style.background = "url('image/" + this.experience.img + "') no-repeat center fixed";
                } else {
                    element.style.background = "url('img/bg_default.jpg') no-repeat center fixed";
                }
                element.style.backgroundSize = 'cover';
            },
            removeBackground: function () {
                let element = document.getElementById('background_image');
                element.style.background = 'unset';
                element.style.backgroundColor = '#E4E4E4';
            }
        }
    };
</script>

<style lang="scss" scoped>

    #content_page, #content_page_layout {
        padding: 0;
    }

    #augmentations_header {
        width: 100%;
        overflow: hidden;
    }

    #augmentations_header .v-image {
        min-height: 110%;
        min-width: 110%;
        left: -5%;
        top: -5%;
        filter: blur(0.15rem);
        position: absolute;
    }

    #augmentations_header .overlay {
        background-color: #393E46;
        opacity: 0.7;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    #header_content {
        text-align: left;
        position: relative;
        margin: 19px 45px 19px 45px;
        z-index: 11;
    }

    .header_content_mobile {
        margin: 25px 45px 25px 45px !important;
    }

    #header_content h3 {
        color: #FFF;
        font-size: 50px !important;
        text-overflow: ellipsis;
        width: 100%;
        overflow: hidden;
    }

    #header_content p {
        color: #FFF;
        font-size: 14px;
        text-overflow: ellipsis;
        width: 90%;
        overflow: hidden;
    }

    #main_box_augment > div {
        width: 100%;
        height: 100%;
        position: absolute;
        background-color: #f1f2f2;
    }

</style>
